import { connect } from 'react-redux';

import { VODCSSModules } from 'shared/utils/wix-connect';
import { getChannelForWidget } from 'shared/selectors/channels';
import Icon from 'shared/components/icon/icon';
import { LinkButton } from 'shared/components/button/button';
import { isChannelShareVisible } from 'shared/utils/layout-helpers';

import ShareChannel from '../share-mobile/share-channel';
import { AccountButtonMobile } from 'widget/components/account/account-button-mobile';
import styles from './header-mobile.styl';


@connect(state => ({
  channelData: getChannelForWidget(state),
  showChannelShare: isChannelShareVisible(state.appSettings),
}))
@VODCSSModules(styles)
export default class HeaderMobile extends React.Component {

  static propTypes = {
    onSubscribeClick: React.PropTypes.func,
    onSubscriptionCancelClick: React.PropTypes.func,
    onUserLogin: React.PropTypes.func,
    onUserLogout: React.PropTypes.func,
    channelData: React.PropTypes.object,
    showChannelShare: React.PropTypes.bool,
    onBackClick: React.PropTypes.func,
    className: React.PropTypes.string,
  };

  get channel() {
    return this.props.channelData;
  }

  get backButton() {
    const { onBackClick } = this.props;

    if (!onBackClick) {
      return null;
    }

    return (
      <LinkButton styleName="back-button"
                  onClick={onBackClick}>
        <Icon styleName="back-button-icon"
              name="permit-search" />
      </LinkButton>
    );
  }

  get shareButton() {
    const { showChannelShare, channelData } = this.props;

    if (!showChannelShare) {
      return null;
    }

    return (
      <ShareChannel channelData={channelData}
                    styleName="info" />
    );
  }

  render() {
    const {
      channelData,
      className,
      onSubscribeClick,
      onSubscriptionCancelClick,
      onUserLogin,
      onUserLogout,
    } = this.props;

    if (!channelData) {
      return null;
    }

    const { title } = channelData;

    return (
      <section styleName="container"
               className={className}>
        {this.backButton}
        <div styleName="channel-name">
          {title}
        </div>
        {this.shareButton}
        <AccountButtonMobile styleName="sign-in"
                             channelData={channelData}
                             onUserLogin={onUserLogin}
                             onUserLogout={onUserLogout}
                             onSubscribeClick={onSubscribeClick}
                             onSubscriptionCancelClick={onSubscriptionCancelClick} />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/header-mobile/header-mobile.js